import Box from "@mui/material/Box";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Tabs from "./tabs";
import PageLoader from "@octopus-settings/components/common/pageLoader";

import useStyles from "./WithWrapperTabs.styles";

const WithWrapperTabs = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Tabs />
      <Box className={classes.content}>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </Box>
    </Box>
  );
};

export default WithWrapperTabs;
